// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__6bp79","transparent":"Modal_transparent__DtSg+","paddingLess":"Modal_paddingLess__QMtJJ","marginLess":"Modal_marginLess__s42B2"};